import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, Output, EventEmitter, } from '@angular/core';

import { MysqlService } from './../../../../services/mysql.service';
import { SubjectNote } from './../../../../api/subjectNote';
import { SubjectBilling } from './../../../../api/subjectBilling';
import {DemoService} from '../../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HotToastService } from '@ngneat/hot-toast';
import { TabsetComponent } from 'ngx-bootstrap';
import { SubjectInvoice } from '../../../../shared/models/subjectInvoice.model';
import { SubjectInvoiceItem } from '../../../../shared/models/subjectInvoiceItem.model';
import { SubjectWorkOrder } from '../../../../shared/models/subjectWorkOrder.model';
import { GlobalFunctionsService } from '../../../../services/global-functions.service';
import { Payment } from '../../../../shared/models/payment.model';

import { ClientInvoiceBulkPaymentWidgetComponent } from './../../../../components/invoices/client-invoice-bulk-payment-widget/client-invoice-bulk-payment-widget.component';
import { MyobApiInvoiceSyncToolsWidgetComponent } from './../../../../components/myob/myob-api-invoice-sync-tools-widget/myob-api-invoice-sync-tools-widget.component';


@Component({
  selector: 'app-subject-billing',
  templateUrl: './subject-billing.component.html',
  styleUrls: ['./subject-billing.component.css']
})
export class SubjectBillingComponent implements OnInit {

  model: SubjectBilling;

  @Input() subject_id: number;
  @Input() job_id: number;
  @Input() file_number: number;

  
  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
// grid other module
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();

//  invoice_model: SubjectInvoice = new SubjectInvoice();
invoice_model: any = SubjectInvoice;
invoice_item_model: any = SubjectInvoiceItem;

work_order_model: any = SubjectWorkOrder;
  

  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  brand_id: any;
  subject_notes: any;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  get_latest_subject_note_id: any;
  subjects: any;
  subject_billing: any;
  get_latest_subject_billing_id: any;
  subject: any;
  subject_number: any;
  job_number: any;
  subject_invoices: any;
  current_invoice_couunt: number;
  subject_progress: any;
  invoice_status: any;
  invoice_status_name: any;
  invoice_status_var: any;
  invoice_payment_status: any;
  invoice_payment_status_name: any;
  invoice_payment_status_var: any;
  invoice_communication_status: any;
  invoice_communication_status_name: any;
  invoice_communication_status_var: any;
  subject_work_orders: any;
  current_work_order_couunt: number;
  current_job_invoice_couunt: number;
  subject_job_invoices: any;
  subject_billing_items: any;
  invoiceItemsList: any = SubjectInvoiceItem;
  paymentModel: any = Payment;
  payment: any;
  myob_checker: any;
  myob_response: boolean;
  subject_template_doc: Object;
  job: Object;

  job_brand_report_id;
  job_brand_invoice_id;
  job_report_client_user: Object;
  report_user_contact_name: string;
  po_number: any;
  document_number: any;
  instructions_date: any;
  f_address: string;
  invoiceItem: Object;
  new_invoice_model: any;

  constructor(
    private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService,
    public gfunc: GlobalFunctionsService,
    public cIBulkPayWid: ClientInvoiceBulkPaymentWidgetComponent,
    public _MyobApiInvoiceSyncToolsWidgetComponent: MyobApiInvoiceSyncToolsWidgetComponent,
       // myob clientInvoiceTools
   public clientInvoiceTools: MyobApiInvoiceSyncToolsWidgetComponent,
  ) {

   

    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
// Set loggind in User Value (USER ID)
this.sessionUserId = this.currentUserVAR.user_id;
this.sessionUsername = this.currentUserVAR.username;
this.sessionBrandId = this.currentUserVAR.brand_id;
this.brand_id = this.sessionBrandId;
// this.toastr.setRootViewContainerRef(vcr);
   }

  ngOnInit() {
    this.model = new SubjectBilling();

    this.getSubjectBilling(this.subject_id);
    this.model.job_id = this.job_id;
    this.model.subject_id = this.subject_id;
    this.getJobSubject(this.subject_id);
    this.getSubjectInvoices(this.subject_id);
  //  this.getSubjectWorkOrders(this.subject_id);
  // this.myob_response = false, // set hide login button, will show if response if false --- never changes so made this false november 2022
  // this.myobChecker();


 
  }

  getSubjectBilling(subject_id) {
    this._demoService.getSubjectBilling(subject_id).subscribe(
      data => { this.subject_billing = data;
       // console.log("Done loadng USER");
        let res = data[0];


      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }


    getJobSubject(subject_id) {
      this._demoService.getJobSubject(subject_id).subscribe(
        data => { this.subject = data;
          let res = data[0];
          this.subject_number = res.subject_number;
          this.job_number = res.job_id + '.1'; // made up
         // console.log("Done loadng USER");
         this.job_id = res.job_id;
           // :: does a check to display a warning that a job invoice has been created for this subject
        this.checkForJobInvoice(res.job_id);

        this.getJob(this.job_id); // set here to load the invoice defaults from the job model
        this.getSubjectTemplateDoc(20); // get the defaults from the invoice
        // get the details from the job



        if (!res.street_address){
          this.f_address = '';
        }else{
          this.f_address = res.street_address +  ' ' + res.suburb +  ' ' + res.state +  ',  ' + res.postcode;
        }



        },
        error => {
        //  console.error('Error Loading User!');
        //return console.log(error);
        }
      ); }


    createSubjectBilling(model){
      this._demoService.createSubjectBilling(model).subscribe(
        data => {  this.get_latest_subject_billing_id = data; // this is the retuned json upon creation.
         this.toastr.info('Subject Billing Created');
         this.getSubjectBilling(this.subject_id); // refresh the data

         this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
         this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));

        },
        error => {
          // console.log(error(error));
          //return console.log(error);
        }
   );
   }

   updateSubjectBilling(model){
    this._demoService.updateSubjectBilling(model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the list
       // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
      this.toastr.success('Subject Billing Updated');
      this.getSubjectBilling(this.subject_id); // refresh the data
            
                this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
                this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
      },
      error => {
       // console.error('Error saving Event!');
        this.toastr.error('Error saving billing details!');
       return console.log(error);
      }
     // err => console.error(err),
     // () => console.log('done updates')
 );
 }


  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
  };

  
 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
  // this.refreshSujectInvoicePage(this.subject_id);
};


// // :: Parent / Child modal test
// refreshParentdGrid() {
//   alert('parent grid component function.');
//  //this.modalRef.hide();
// this.refreshGrid(); // resets the grid if updated and closed.
// //  this.updateTypeClick = false; // closes the div
// };

refreshSujectInvoicePage(subject_id){
  // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
  //               this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));
                this.gfunc.globalJobSubjectBillingViewSkipRoute(subject_id);

}


getSubjectInvoices(subject_id) {
  this._demoService.getSubjectInvoices(subject_id).subscribe(
     data => { this.subject_invoices = data;
   let res = data[0];
  // this.subject_invoices = res; // only return the first result and save back the the same variable.
   // do a count if exists

   let newArr = Object(this.subject_invoices);
   this.current_invoice_couunt = Object.keys(newArr).length;

   // only loads the one result!!!!! hard CDODE....
    // this.getPaymentByInvoiceID(res.invoice_id);
    if (this.current_invoice_couunt >= 1) {
    this.getPaymentByInvoiceID(res.invoice_id);
    }


    }, // make the same data call for all
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




 
 checkForJobInvoice(job_id) {
  this._demoService.checkForJobInvoice(job_id).subscribe(
     data => { this.subject_job_invoices = data;
   let res = data[0];
  // this.subject_invoices = res; // only return the first result and save back the the same variable.
   // do a count if exists
   let newArr2 = Object(this.subject_job_invoices);
   this.current_job_invoice_couunt = Object.keys(newArr2).length;

    }, // make the same data call for all
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getSubjectWorkOrders(subject_id) {
  this._demoService.getSubjectWorkOrders(subject_id).subscribe(
     data => { this.subject_work_orders = data;
   let res = data[0];
  // this.subject_invoices = res; // only return the first result and save back the the same variable.
   // do a count if exists
   let newArr = Object(this.subject_work_orders);
   this.current_work_order_couunt = Object.keys(newArr).length;

    }, // make the same data call for all
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getSubjectProgress(job_id, file_number){
  this._demoService. getSubjectProgress(job_id, file_number)
  .subscribe(
    res => this.subject_progress = res,
    err => console.error(err.status)
  );
 }


 updateInvoiceStatus(invoice_model){
  invoice_model.invoice_status_id = 3; // approved
  this._demoService.updateInvoiceStatus(invoice_model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the invoice:
      this.gfunc.insertLog_UpdateInvoice(invoice_model);
      this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
    },
    error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Changing Status of Subject');
      return console.error(error);
    }
   // err => console.error(err),
   //
  )};


  approveAndPDF(model, invoice_id){

    // this.updateInvoiceStatus(invoice_model);
    // this.createSubjectInvoicePDF(invoice_model, invoice_model.invoice_id)
    this.createSubjectInvoicePDF(model, invoice_id)
    

  }

  approveAndPDFAndSend(invoice_model){

    this.updateInvoiceStatus(invoice_model);
    // this.createSubjectInvoicePDF(invoice_model, invoice_model.invoice_id)
    this.createSubjectInvoicePDFAndSend(invoice_model, invoice_model.invoice_id);
  

  }


// Do some delays....  and see what happends abit 2 secpmds betwen each...

  approveAndPDFAndSendAndPush(model, invoice_id, invoice_model){

    // this.updateInvoiceStatus(invoice_model);
    // this.createSubjectInvoicePDF(invoice_model, invoice_model.invoice_id)

    this.toastr.info("Sending + Creating PDF")
    //  this.createSubjectInvoicePDFAndSend(invoice_model, invoice_model.invoice_id);
     this.createSubjectInvoicePDFAndSend(model, invoice_id);


    setTimeout(() => {  
      this.toastr.info("Gathering updated invoice datas, ready for Sync")
      this.getInvoice(invoice_model.invoice_id, invoice_model)
      }, 2500);
    /// Mow Sync the invoice with MYOB. -- link to function through components 

    // setTimeout(() => {  

    //   // Need to lookup invoice status

    //     // Set the same model as above so that the correct invoice details

    //   this.toastr.info("Starting Sync")
    //   // invoice_model = this.invoiceItem // set to updated invoice item above.
   
    
    //   }, 6000);
    
  

  }





  approveAndPDFAndPush(model, invoice_id, invoice_model){

    // this.updateInvoiceStatus(invoice_model);
    // this.createSubjectInvoicePDF(invoice_model, invoice_model.invoice_id)

    this.toastr.info("Sending + Creating PDF")
    //  this.createSubjectInvoicePDFAndPush(invoice_model, invoice_model.invoice_id); // was using the wrong data sept 24
    this.createSubjectInvoicePDFAndPush(model, invoice_id);
  
  

    setTimeout(() => {  
      this.toastr.info("Gathering updated invoice datas, ready for Sync")
      this.getInvoice(invoice_id, invoice_model)
      }, 2500);
    /// Mow Sync the invoice with MYOB. -- link to function through components 

    // setTimeout(() => {  

    //   // Need to lookup invoice status

    //     // Set the same model as above so that the correct invoice details

    //   this.toastr.info("Starting Sync")
    //   // invoice_model = this.invoiceItem // set to updated invoice item above.
   
    
    //   }, 6000);
    
  

  }




// REFRESH AND SYNC INVOICE 
// Customised for muilple function
  getInvoice(invoice_id, invoice_model){
    this._demoService.getSubjectInvoice(invoice_id).subscribe(
      (data) => {
        this.invoiceItem = data;

        this.new_invoice_model = {
          ...data[0]
        }
        
      this.clientInvoiceTools.setMyobInvoiceModelStep1(this.new_invoice_model);

        // let res = data[0];
        // this.invoice_number = res.invoice_number;
   
        // // Set status based in ID - For template interactions // RULES
        // // this.invoice_status_text = 'PAID';
        // this.getInvoiceStatus(res.invoice_status_id);
        // this.getInvoicePaymentStatus(res.invoice_payment_status_id);
        // this.getInvoiceCommunicationStatus(res.invoice_communication_status_id);
   
       // this.invoice_model = this.invoiceItem;
    
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    ) };




 getInvoiceStatus(invoice_status_id){
  this._demoService.getInvoiceStatus(invoice_status_id).subscribe(
    (data) => {
      this.invoice_status = data;
      let res = data[0];
      this.invoice_status_name = res.invoice_status_name;
      this.invoice_status_var = invoice_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}



getInvoicePaymentStatus(invoice_payment_status_id){
  this._demoService.getInvoicePaymentStatus(invoice_payment_status_id).subscribe(
    (data) => {
      this.invoice_payment_status = data;
      let res = data[0];
      this.invoice_payment_status_name = res.invoice_payment_status_name;
      this.invoice_payment_status_var = invoice_payment_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getInvoiceCommunicationStatus(invoice_communication_status_id){
  this._demoService.getInvoiceCommunicationStatus(invoice_communication_status_id).subscribe(
    (data) => {
      this.invoice_communication_status = data;
      let res = data[0];
      this.invoice_communication_status_name = res.invoice_communication_status_name;
      this.invoice_communication_status_var = invoice_communication_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}



deleteInvoiceAndSetBillingItems(invoice_model){
  if (confirm('Are you sure you want to delete this invoice Myob and Sop. All items will be placed back into specific subject billing items, yet to be invoiced.')) {
  // get all items and loop 
 // :: Remove from myob

 if (invoice_model.myob_id) { // delete from myob
 this._MyobApiInvoiceSyncToolsWidgetComponent.deleteMyobServiceInvoiceModel(invoice_model);
 };

  // remove function and update subject billing items "not-invoiced"
  // end loop
console.log("InvoiceID: " + invoice_model.invoice_id);
  // this.getInvoiceItmes(invoice_model.invoice_id);
  this._demoService.getSubjectInvoiceItems(invoice_model.invoice_id).subscribe(
    (data) => {
      this.invoiceItemsList = data;
      let res = data[0];
     // this.invoice_item_model = this.invoiceItemsList;
     console.log( JSON.stringify(this.invoiceItemsList) );
      let newArr = data;
          let  count_of_items = Object.keys(newArr).length;
          for(let i=0;i < count_of_items; i++) {
                  let res = newArr[i];
                  // console.log('Item:' + i + ' ID: ' + res.invoice_item_id);
                  this.deleteSubjectInvoiceItem(res, res.invoice_item_id);
                  // this updates the status NOT invoice of all subject invoice itmes;
          }// end for loop
  // then remove invoice_items and invoice data rows
        this.deleteInvoiceAndItems(invoice_model);
        this.toastr.success('Invoice Removed and Subject Billing Items used now set "Not Invoiced".');
        // Now Reload the page.

        this.gfunc.insertLog_DeleteInvoice(invoice_model);
        this.refreshSujectInvoicePage(this.subject_id);
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
    ); // end subscribe.
} // end confirm
}


     
getInvoiceItmes(invoice_id){
  this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
    (data) => {
      this.invoiceItemsList = data;
      let res = data[0];
      this.invoice_item_model = this.invoiceItemsList;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  ) };





deleteInvoiceAndItems(model) {
  // if (confirm('Are you sure you want to delete this invoice and items? ')) {
    this._demoService.deleteInvoice(model.invoice_id).subscribe(
       data => {
       //  this.getTraceCandidateNotes(this.trace_candidate_id);
         return true;
       },
       error => {
         console.error('Error deleting Invoice!');
        return console.log(error);
       }
    );
// }
}


deleteSubjectInvoiceItem(model, invoice_item_id){
  // if (confirm('Are you sure you want to delete this item from the invoice. It will still appear in billing items, yet to be invoiced.')) {
    this._demoService.deleteSubjectInvoiceItem(model, invoice_item_id).subscribe(
       data => {
        // update the status of subjectbillingItems
        let invoice_status = 'NOT-INVOICED';
        let invoice_id = model.invoice_id;
        let invoice_number = model.invoice_number; // error this fixed was set for invoice ID>... this fixed the data on invoice items

        let subject_billing_item_id = model.subject_billing_item_id;
        this.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, model);
        // refresh the list
       ////  this.getSubjectBillingItems(this.invoice_id); // seemed to remove all items from the list??? upon delete when they are still in the database...
        // refresh the bottom widow of sibjectBillingItems from Modal
        // this.refreshSujectInvoicePage(this.subject_id);
        /// :: lets do a refresh of the invoice data to refresh the invoice_items_list.
        // this.getInvoiceItmes(this.invoice_id);
         return true;
       },
       error => {
         console.error('Error deleting Invoice Items Data!');
         console.error(error);
         //return console.log(error);
       }
    );
// }
}


updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model){
  this._demoService.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(error(error));
      //return console.log(error);
    }
)
 }




// :: New sytem to Automatically be able to create documents and send via comm templates.


createSubjectInvoicePDF(model, invoice_id) {
  model.doc_id = 20; // client invoice
  model.subject_com_type_id = 3;
  model.allAttachments = []; // so we can push to an empty array.
  model.is_encrypted = 0;
  
  model.updated_by = this.gfunc.sessionUserId
  model.updated_date = this.gfunc.today

  // upgrade for report user name to be on invoice - 29/01/24
  model.brand_report_user_name = this.report_user_contact_name;

  // Set the extra fields and get the "if  applicale" value here by default....
  if(this.f_address == ""){
    model.f_address = "if applicable"
  }else{
    model.f_address = this.f_address
  }
  if(this.document_number == ""){
    model.document_number = "if applicable"
  }else{
    model.document_number = this.document_number
  }
  if(this.instructions_date == ""){
    model.instructions_date = "if applicable"
  }else{
    model.instructions_date = this.instructions_date
  }



// See Global Function to See Vars
this.gfunc.createDocument_Invoice(model, invoice_id);
}

// DEC 2022 - Better Gobal Create Comms From Button + Send. FIXED

createSubjectInvoicePDFAndSend(model, invoice_id) {

  model.doc_id = 20; // client invoice
  model.subject_com_type_id = 3; // 3 client commynication
  model.is_encrypted = 0;

  model.updated_by = this.gfunc.sessionUserId
  model.updated_date = this.gfunc.today

    // upgrade for report user name to be on invoice - 29/01/24
    model.brand_report_user_name = this.report_user_contact_name;

  // upgrade for report user name to be on invoice - 29/01/24
  model.brand_report_user_name = this.report_user_contact_name;

  // upgrade for report user name to be on invoice - 29/01/24
  model.brand_report_user_name = this.report_user_contact_name;

  // Set the extra fields and get the "if  applicale" value here by default....
  if(this.f_address == ""){
    model.f_address = "if applicable"
  }else{
    model.f_address = this.f_address
  }
  if(this.document_number == ""){
    model.document_number = "if applicable"
  }else{
    model.document_number = this.document_number
  }
  if(this.instructions_date == ""){
    model.instructions_date = "if applicable"
  }else{
    model.instructions_date = this.instructions_date
  }



  // Set the extra fields and get the "if  applicale" value here by default....
  if(this.f_address == ""){
    model.f_address = "if applicable"
  }else{
    model.f_address = this.f_address
  }
  if(this.document_number == ""){
    model.document_number = "if applicable"
  }else{
    model.document_number = this.document_number
  }
  if(this.instructions_date == ""){
    model.instructions_date = "if applicable"
  }else{
    model.instructions_date = this.instructions_date
  }




// See Global Function to See Vars
// :: Extra Vars to Establish the send.

// model.brand_type_id = 2; // client 2 agent 3
// model.brand_report_id = 97; // current subject job details
// model.brand_invoice_id = 97; // current subject job details

model.brand_type_id = 2; // client 2 agent 3
model.brand_report_id = this.job[0].brand_report_id; // current subject job details
model.brand_invoice_id = this.job[0].brand_invoice_id; // current subject job details


// set these up below to truly automate the sending of the invoice action.
// this.subject_template_doc[0].send_to_invoice;
/// 

console.log('this.subject_template_doc[0].send_to_invoice: ', this.subject_template_doc[0].send_to_invoice);
// model.brand_work_order_id = null;
// model.send_to_invoice = 1; // 1 or 0
// model.send_to_report = 0; // 1 or 0
// model.send_to_logins = 0; // 1 or 0
// model.send_to_report_user = 0; // 1 or 0 // TODO not yet datbased API or coded into the system process
model.brand_work_order_id = null;
model.send_to_invoice = this.subject_template_doc[0].send_to_invoice; // 1 or 0
model.send_to_report = this.subject_template_doc[0].send_to_report; // 1 or 0
model.send_to_logins = this.subject_template_doc[0].send_to_logins; // 1 or 0
model.send_to_report_user = this.subject_template_doc[0].send_to_report_user; // 1 or 0 // TODO not yet datbased API or coded into the system process
model.additional_message = "Automated Client Invoice Email Via button Press " + this.gfunc.today;
model.allAttachments = [];

this.gfunc.createDocument_InvoiceAndSend(model, invoice_id);
}


createSubjectInvoicePDFAndPush(model, invoice_id) {

  model.doc_id = 20; // client invoice
  model.subject_com_type_id = 3; // 3 client commynication
  model.is_encrypted = 0;

  model.updated_by = this.gfunc.sessionUserId
  model.updated_date = this.gfunc.today

    // upgrade for report user name to be on invoice - 29/01/24
    model.brand_report_user_name = this.report_user_contact_name;

  // upgrade for report user name to be on invoice - 29/01/24
  model.brand_report_user_name = this.report_user_contact_name;

  // upgrade for report user name to be on invoice - 29/01/24
  model.brand_report_user_name = this.report_user_contact_name;

  // Set the extra fields and get the "if  applicale" value here by default....
  if(this.f_address == ""){
    model.f_address = "if applicable"
  }else{
    model.f_address = this.f_address
  }
  if(this.document_number == ""){
    model.document_number = "if applicable"
  }else{
    model.document_number = this.document_number
  }
  if(this.instructions_date == ""){
    model.instructions_date = "if applicable"
  }else{
    model.instructions_date = this.instructions_date
  }



  // Set the extra fields and get the "if  applicale" value here by default....
  if(this.f_address == ""){
    model.f_address = "if applicable"
  }else{
    model.f_address = this.f_address
  }
  if(this.document_number == ""){
    model.document_number = "if applicable"
  }else{
    model.document_number = this.document_number
  }
  if(this.instructions_date == ""){
    model.instructions_date = "if applicable"
  }else{
    model.instructions_date = this.instructions_date
  }




// See Global Function to See Vars
// :: Extra Vars to Establish the send.

// model.brand_type_id = 2; // client 2 agent 3
// model.brand_report_id = 97; // current subject job details
// model.brand_invoice_id = 97; // current subject job details

model.brand_type_id = 2; // client 2 agent 3
model.brand_report_id = this.job[0].brand_report_id; // current subject job details
model.brand_invoice_id = this.job[0].brand_invoice_id; // current subject job details


// set these up below to truly automate the sending of the invoice action.
// this.subject_template_doc[0].send_to_invoice;
/// 

console.log('this.subject_template_doc[0].send_to_invoice: ', this.subject_template_doc[0].send_to_invoice);
// model.brand_work_order_id = null;
// model.send_to_invoice = 1; // 1 or 0
// model.send_to_report = 0; // 1 or 0
// model.send_to_logins = 0; // 1 or 0
// model.send_to_report_user = 0; // 1 or 0 // TODO not yet datbased API or coded into the system process
model.brand_work_order_id = null;
model.send_to_invoice = this.subject_template_doc[0].send_to_invoice; // 1 or 0
model.send_to_report = this.subject_template_doc[0].send_to_report; // 1 or 0
model.send_to_logins = this.subject_template_doc[0].send_to_logins; // 1 or 0
model.send_to_report_user = this.subject_template_doc[0].send_to_report_user; // 1 or 0 // TODO not yet datbased API or coded into the system process
model.additional_message = "Automated Client Invoice Email Via button Press " + this.gfunc.today;
model.allAttachments = [];

// this.gfunc.createDocument_InvoiceAndSend(model, invoice_id);

this.gfunc.createDocument_Invoice(model, invoice_id);



}



getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
     data => { this.job = data;
      let res = data[0];
      // Need to load the drop downs (only if a process is selected.)
      // this.getJobTypeLocations(res.job_type_id);
      // this.getJobTypeCourts(res.job_type_location_id);
      // this.getJobTypeDocumentTypes(res.job_type_court_id);
      // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);

      // this.getJobPlaintiffs(job_id);
      this.job_brand_report_id = data[0].brand_report_id;
      this.job_brand_invoice_id = data[0].brand_invoice_id;
      console.log('job_brand_report_id: ', this.job_brand_report_id);
      console.log('job_brand_invoice_id: ', this.job_brand_invoice_id);
      console.log('job_brand_invoice_id - no va: ', this.job[0].brand_invoice_id);




      this.po_number = res.owner_trace_code;
      this.document_number = res.document_number;
      this.instructions_date = res.instructions_date;


            // show the report user name on invoices 29/01/24
            this.getJobReportUser(res.brand_report_user_id)

    
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


getSubjectTemplateDoc(doc_id) {
  this._demoService.getSubjectTemplateDoc(doc_id).subscribe(
    data => { this.subject_template_doc = data;
      const res = data[0];
      // load the drop downs
      // this.getJobTypeLocations(res.job_type_id);
      // this.getJobTypeCourts(res.job_type_location_id);
      // this.getJobTypeDocumentTypes(res.job_type_court_id);
      // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
      // this.getJobTypes();

    },
    err => console.error(err),
    () => console.log('')
  );
}



getPayment(payment_id){
  this._demoService.getPayment(payment_id).subscribe(
    (data) => {
      this.payment = data;
      this.paymentModel = this.getPayment;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}

getPaymentByInvoiceID(invoice_id){
  this._demoService.getPaymentByInvoiceID(invoice_id).subscribe(
    (data) => {
      this.payment = data;
      this.paymentModel = this.getPayment;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}

myobChecker() {
  this._demoService.myobChecker().subscribe(
     data => { this.myob_checker = data;
      let res = data[0];
      // this.toastr.success('Myob Connections Active!... functions allowed');
// console.log('Connected: ', JSON.stringify(this.myob_checker));
this.myob_response == true;
    },
     err => (
      // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
      this.myob_response == false,
      console.error(err)
     ),
     // () => console.log('done loading Trace Types')
   );
 }





      // show the report user name on invoices 29/01/24
      getJobReportUser(brand_report_user_id) {
        this._demoService.getUsersById(brand_report_user_id).subscribe(
           data => { 
                this.job_report_client_user = data;
    
                this.report_user_contact_name = this.job_report_client_user[0].first_name + ' ' + this.job_report_client_user[0].surname;
    
          },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }

}
